<script setup lang="ts">
const {
    height = 4,
    backgroundColor = 'var(--blue-200)',
    progressColor = 'var(--blue-400)',
    progress = 5,
} = defineProps<{
    progress: number;
    customProgressImg?: string;
    progressColor?: string;
    backgroundColor?: string;
    height?: number;
}>();
</script>

<template>
    <div
        class="progress-bar"
        :style="{
            height: `${height}px`,
            backgroundColor,
        }"
    >
        <div
            class="progress"
            :style="{
                width: `${progress}%`,
                backgroundImage: customProgressImg,
                backgroundColor: progressColor,
            }"
        />
    </div>
</template>

<style scoped lang="scss">
.progress-bar {
    width: 100%;
    border-radius: 37px;
    .progress {
        height: 100%;
        border-radius: 37px;
        background-size: cover;
        background-repeat: repeat-x;
        transition: width 1s ease-in-out;
    }
}
</style>
